<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="user_verify"
    data-name="user verify"
    xmlns="http://www.w3.org/2000/svg"
    width="70"
    height="70"
    viewBox="0 0 70 70"
  >
    <path id="Path_8358" data-name="Path 8358" d="M0,0H70V70H0Z" fill="none" />
    <g id="Group_972" data-name="Group 972" transform="translate(18.5 17)">
      <path
        id="Path_8360"
        data-name="Path 8360"
        d="M5,22.818H5a7.265,7.265,0,0,1,7.265-7.265h8.342a7.265,7.265,0,0,1,7.265,7.265h0"
        transform="translate(0 7.322)"
        fill="none"
        :stroke="clr ? clr : '#768391'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="3.5"
      />
      <path
        id="Path_8361"
        data-name="Path 8361"
        d="M19.6,6.034a6.943,6.943,0,1,1-9.82,0,6.943,6.943,0,0,1,9.82,0"
        transform="translate(1.743 0)"
        :fill="clr ? clr : '#500fe9'"
        :stroke="clr ? clr : '#768391'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="3.5"
      />
    </g>
    <path
      id="Path_8359"
      data-name="Path 8359"
      d="M16.125,3H8.833A5.832,5.832,0,0,0,3,8.833v7.292m0,26.25v7.292A5.832,5.832,0,0,0,8.833,55.5h7.292m26.25,0h7.292A5.832,5.832,0,0,0,55.5,49.667V42.375m0-26.25V8.833A5.832,5.832,0,0,0,49.667,3H42.375"
      transform="translate(5.75 5.75)"
      fill="none"
      :stroke="clr ? clr : '#768391'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3.5"
    />
    <path
      id="Path_8362"
      data-name="Path 8362"
      d="M0,0H40"
      transform="translate(14.5 31.5)"
      fill="none"
      :stroke="clr ? clr : '#768391'"
      stroke-linecap="round"
      stroke-width="4"
    />
  </svg>
</template>
